<template>
  <div>
    <div class="authen_content">
      <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
        <el-tab-pane label="实名认证" name="first">
          <enterprisePage1></enterprisePage1>
        </el-tab-pane>
        <el-tab-pane label="个人职业认证" name="second">
          <enterprisePage2></enterprisePage2>
        </el-tab-pane>
        <el-tab-pane label="企业认证" name="third">
          <enterprisePage3></enterprisePage3>
        </el-tab-pane>
        <!-- <el-tab-pane label="联盟认证" name="four">
					<enterprisePage4></enterprisePage4>
				</el-tab-pane> -->
      </el-tabs>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref } from "vue";
import enterprisePage1 from "./enterprisePage1.vue";
import enterprisePage2 from "./enterprisePage2.vue";
import enterprisePage3 from "./enterprisePage3.vue";
import enterprisePage4 from "./enterprisePage4.vue";
const props = defineProps({
  title: {
    default: "0",
  },
});
let activeName = ref("first");
activeName.value = props.title || "first";
console.log(activeName.value);
console.log("activeName.value ");

const handleClick = (tab, event) => {
  // console.log(tab, event);
};
</script>

<style scoped>
/deep/.el-tabs__nav-wrap::after {
  display: block !important;
}
/deep/.el-tabs__item.is-active {
  color: #C01A26 !important;
  background: transparent !important;
  border-radius: 0rem !important;
  border-bottom: 1px solid #C01A26 !important;
}
</style>
